import {
  EducationDetails,
  EmployeeRelations,
  EmploymentHistory,
  FamilyDetails,
  PrevApplications,
  References,
} from "../../../types/Form-types";

export type InterviewAssessmentTypes = {
  source: string;
  position: string;

  candidateName: string;
  gender: string;
  dateOfBirth: string;
  department: string;
  Address: string;
  permanentAddress: string;
  mobileNo: string;
  maritalStatus: string;
  emailId: string;

  langSpeak: string;
  langRead: string;
  langWrite: string;

  careerGoal: string;
  strength: string;
  weakness: string;
  relationShip: boolean;
  applied_previously: boolean;

  current_ctc: number | string;
  expected_ctc: number | string;
  notice_period_days: number | string;
  convicted_in_court: string;

  final_hr_recommendation: string;
  grade_designation_allocated: string;
  ctc_to_be_offered: number | string;
  onboarding_date: string;

  education_details: EducationDetails[];
  family_details: FamilyDetails[];
  employment_history: EmploymentHistory[];
  employee_relations: EmployeeRelations[];
  prev_applications: PrevApplications[];
  references: References[];
};

export const sourceOptions = [
  { key: "A", label: "Employee Reference" },
  { key: "B", label: "Placement Consultant" },
  { key: "C", label: "Direct" },
  { key: "D", label: "Job Portal" },
];

type FieldConfig = {
  label: string;
  key: keyof InterviewAssessmentTypes;
  type: string;
  subType?: string;
};

export const personalFields: FieldConfig[] = [
  { label: "Date of Birth (dd/mm/yyyy):", key: "dateOfBirth", type: "date" },
  { label: "Department:", key: "department", type: "text" },
  { label: "Present Address:", key: "Address", type: "text" }, // ⚠️ FIXED
  { label: "Permanent Address:", key: "permanentAddress", type: "text" },
  {
    label: "Mobile No:",
    key: "mobileNo",
    type: "number",
    subType: "indian_number",
  },
  // { label: "Marital Status:", key: "maritalStatus", type: "text" },
  { label: "Email ID:", key: "emailId", type: "email" },
];
export const employment_textAreaQuestions = [
  {
    label: "1. What are your career goals in next five years?",
    name: "careerGoal",
    rows: 2,
  },
];

export const FieldLabels: Record<string, string> = {
  source: "Source",
  position: "Position",
  candidateName: "Candidate Name",
  gender: "Gender",
  dateOfBirth: "Date of Birth",
  department: "Department",
  Address: "Current Address",
  permanentAddress: "Permanent Address",
  mobileNo: "Mobile Number",
  maritalStatus: "Marital Status",
  emailId: "Email ID",
  langSpeak: "Language (Speak)",
  langRead: "Language (Read)",
  langWrite: "Language (Write)",
  careerGoal: "Career Goal",
  strength: "Strength",
  weakness: "Weakness",
  current_ctc: "Current CTC",
  expected_ctc: "Expected CTC",
  notice_period_days: "Notice Period",
  convicted_in_court: "Convicted in Court",
  final_hr_recommendation: "Final HR Recommendation",
  grade_designation_allocated: "Grade / Designation",
  ctc_to_be_offered: "CTC to be Offered",
  onboarding_date: "Onboarding Date",

  // eval fields
  interviewer_name: "Interviewer Name",
  interview_datetime: "Interview Date & Time",
  selection_criteria: "Selection Criteria",
  rating_technical_knowledge: "Technical Knowledge Rating",
  rating_functional_qualification: "Functional Qualification Rating",
  rating_communication_skills: "Communication Skills Rating",
  rating_confidence_level: "Confidence Level Rating",
  rating_body_language: "Body Language Rating",
  recommendation: "Recommendation",
  remarks: "Remarks",
};
